const urlEndpoint = "/campaign/promotion/qrCode/method/getInfoQrCode";

export const getPromoData = async (accessToken, setPromoState) => {
  try {
    const res = await fetch(process.env.REACT_APP_API_URL + urlEndpoint, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    });

    const response = await res.json();
    //* La respuesta devolvió un 202 pero dentro tiene un cod 404
    //* Significa que el cliente no tiene canjeada la promoción
    if (response?.cod === "404") {
      setPromoState((prevState) => ({
        ...prevState,
        loadingPromo: false,
        alreadyTaken: false,
        error: false,
      }));
    } else if (response?.cod === "200") {
      setPromoState((prevState) => ({
        ...prevState,
        loadingPromo: false,
        alreadyTaken: true,
        error: false,
      }));
    }
    //* Vamos a asumir que la otra opción es que el cliente ya haya reclamado
    //* Seguramente tenga un código para este caso
    else {
    }
    //! Caso de error en caso de que la respuesta no sea un código esperado
  } catch (error) {
    setPromoState((prevState) => ({
      ...prevState,
      loadingPromo: false,
      error: true,
      errorMessage: error?.message || "Something went wrong",
    }));
  }
};
